import { render, staticRenderFns } from "./PreviewFileExcel.vue?vue&type=template&id=105a20ff&scoped=true"
import script from "./PreviewFileExcel.vue?vue&type=script&lang=ts"
export * from "./PreviewFileExcel.vue?vue&type=script&lang=ts"
import style0 from "./PreviewFileExcel.vue?vue&type=style&index=0&id=105a20ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a20ff",
  null
  
)

export default component.exports